// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ObrigadoRouteImport } from './routes/obrigado'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'

const ObrigadoRoute = ObrigadoRouteImport.update({
            id: '/obrigado',path: '/obrigado',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/admin/leads',path: '/admin/leads',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ObrigadoRoute: ObrigadoRoute,AdminLeadsRoute: AdminLeadsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)